import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "@phosphor-icons/react";

const KEY = "cookie_consent_v1";

export default function CookieConsent() {
    const [show, setShow] = useState(false);

    useEffect(() => {
        if (!localStorage.getItem(KEY)) setShow(true);
    }, []);

    if (!show) return null;

    const accept = () => {
        localStorage.setItem(KEY, new Date().toISOString());
        setShow(false);
    };

    return (
        <div
            data-testid="cookie-banner"
            className="fixed bottom-4 right-4 left-4 md:left-auto md:max-w-md z-[100] border border-gray-200 bg-white/95 backdrop-blur shadow-[0_8px_30px_rgba(0,0,0,0.15)] rounded-xl"
        >
            <div className="px-5 py-4 flex flex-col gap-3">
                <Cookie size={22} weight="fill" className="shrink-0 text-gray-700" />
                <p className="text-xs text-gray-600 leading-relaxed flex-1">
                    Utilizziamo esclusivamente <strong>cookie tecnici</strong> necessari al
                    funzionamento e alla sicurezza della piattaforma. Non usiamo cookie di
                    profilazione. Maggiori dettagli nella{" "}
                    <Link to="/cookie" className="underline font-semibold hover:text-black">Cookie Policy</Link>.
                </p>
                <div className="flex items-center gap-2 shrink-0">
                    <Link
                        to="/cookie"
                        data-testid="cookie-policy-link"
                        className="h-9 px-3 inline-flex items-center text-xs font-semibold text-gray-600 hover:text-black border border-gray-200 hover:border-black transition-colors"
                    >
                        Dettagli
                    </Link>
                    <button
                        onClick={accept}
                        data-testid="cookie-accept-button"
                        className="h-9 px-5 bg-[#FFFFFF] text-[#0A0A0A] text-xs font-bold rounded-full hover:bg-[#00E599] transition-colors"
                    >
                        Ho capito
                    </button>
                </div>
            </div>
        </div>
    );
}
